import React from 'react'
import Auth from './auth'

const Join = () => <Auth startInLogin={false} />

export default Join
